module.exports = __webpack_public_path__ + "static/media/close.52060667.svg";